import { ActionType, createAction, createAsyncAction } from "typesafe-actions";

import { AnyEntity } from "@mapmycustomers/shared/types/entity";

import ViewMode from "@app/enum/dashboard/ViewMode";
import DrillDownViewState from "@app/scene/dashboard/types/DrillDownViewState";
import { TabbedDrillDownListFetcherPayload } from "@app/scene/dashboard/types/TabbedDrillDownListFetcher";
import EntityTypesSupportedInFrequencyCoverage from "@app/types/dashboard/cards/frequencyCoverage/EntityTypesSupportedInFrequencyCoverage";
import FrequencyCoverageCardConfiguration from "@app/types/dashboard/cards/frequencyCoverage/FrequencyCoverageCardConfiguration";
import Scope from "@app/types/dashboard/Scope";
import MapViewportState from "@app/types/map/MapViewportState";

import FrequencyCoverageCardData from "./FrequencyCoverageCardData";

export const fetchFrequencyCoverageCardData = createAction(
  "@dashboard/fetchFrequencyCoverageCardData"
)<{
  callback: (data: FrequencyCoverageCardData) => void;
  configuration: FrequencyCoverageCardConfiguration;
  failureCallback?: () => void;
  offset?: number; // used with List view mode when we need to load more items
  scope?: Scope;
  viewMode: ViewMode;
  viewport?: MapViewportState; // used with Map view mode when user pans/zooms
}>();

export const showFrequencyCoverageDrillDown = createAsyncAction(
  "@dashboard/showFrequencyCoverageCardDrillDownModal/request",
  "@dashboard/showFrequencyCoverageCardDrillDownModal/success",
  "@dashboard/showFrequencyCoverageCardDrillDownModal/failure"
)<
  {
    configuration: FrequencyCoverageCardConfiguration;
    scope: Scope;
  },
  { viewStates: Record<EntityTypesSupportedInFrequencyCoverage, DrillDownViewState> },
  unknown
>();

export const hideFrequencyCoverageDrillDown = createAction(
  "@dashboard/hideFrequencyCoverageCardDrillDownModal"
)<void>();

export const fetchFrequencyCoverageCardDrillDownData = createAsyncAction(
  "@dashboard/fetchFrequencyCoverageCardDrillDownData/request",
  "@dashboard/fetchFrequencyCoverageCardDrillDownData/success",
  "@dashboard/fetchFrequencyCoverageCardDrillDownData/failure"
)<
  TabbedDrillDownListFetcherPayload<AnyEntity, EntityTypesSupportedInFrequencyCoverage>,
  {
    entityType: EntityTypesSupportedInFrequencyCoverage;
    totalFilteredRecords: number;
    totalRecords: number;
  },
  unknown
>();

export const applyFrequencyCoverageDrillDownListViewSettings = createAction(
  "@dashboard/applyFrequencyCoverageDrillDownListViewSettings"
)<Partial<DrillDownViewState> & { entityType: EntityTypesSupportedInFrequencyCoverage }>();

export const exportFrequencyCoverageCardDrillDownData = createAction(
  "@dashboard/exportFrequencyCoverageCardData"
)<{
  configuration: FrequencyCoverageCardConfiguration;
  entityType: EntityTypesSupportedInFrequencyCoverage;
  scope: Scope;
}>();

export type FrequencyCoverageCardActions = ActionType<
  | typeof applyFrequencyCoverageDrillDownListViewSettings
  | typeof exportFrequencyCoverageCardDrillDownData
  | typeof fetchFrequencyCoverageCardData
  | typeof fetchFrequencyCoverageCardDrillDownData
  | typeof hideFrequencyCoverageDrillDown
  | typeof showFrequencyCoverageDrillDown
>;
